// extracted by mini-css-extract-plugin
export default {"button":"CopyButton_button__mjumF"};